const PUBLIC_PRODUCT_FILTER_CONFIG = function(opt) {
	return [{
		label: '推荐方式',
		type: 'group',
		groupStyle: false,
		code: 'select_type',
		options: [{
			name: '按条件',
			value: 1,
			content: [{
				label: '所属品牌',
				type: 'select',
				code: 'brand',
				options: 'BRAND'
			}, {
				label: '所属分类',
				type: 'select',
				code: 'classify_ids',
				options: 'PRODUCT_CLASSIFY',
				multiple: true
			}, {
				label: '参与活动',
				type: 'select',
				code: 'activity',
				options: 'ACTIVITY'
			}, {
				label: '排序规则',
				type: 'select',
				code: 'sort_type',
				options: [{
					name: '按综合排序',
					value: 'overall desc'
				}, {
					name: '按上架时间降序',
					value: 'sell_state_date desc'
				}, {
					name: '按销量降序',
					value: 'product_count desc'
				}]
			}]
		}, {
			name: '手动推荐',
			value: 2,
			content: [{
				label: '手动选择',
				type: 'product',
				code: 'product_ids'
			}]
		}]
	}];
};

const link_area = {
	name: '自定义热区',
	config: [{
		tab: '内容设置',
		content: [{
			type: 'link_area',
			code: 'data'
		}]
	}]
}

export {PUBLIC_PRODUCT_FILTER_CONFIG, link_area};